import { __awaiter, __generator } from "tslib";
function _emitSignature(message, color) {
    console.log(message, color);
    return undefined;
}
export function setImageUrlFromFile(data, options) {
    var _this = this;
    var _emit = options._emit, genericApiService = options.genericApiService, setStateValue = options.setStateValue;
    return (function (dispatch) { return __awaiter(_this, void 0, void 0, function () {
        var url, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4, genericApiService.getImageUrl({ imageKey: data.imageKey })];
                case 1:
                    url = (_a.sent()).url;
                    dispatch(setStateValue({ key: data.imageUrlStatePath, value: url }));
                    return [3, 3];
                case 2:
                    e_1 = _a.sent();
                    console.error(e_1);
                    dispatch(_emit("Error getting the image url.", "error"));
                    return [3, 3];
                case 3: return [2];
            }
        });
    }); });
}
//# sourceMappingURL=setImageUrlFromFile.js.map